import { isEmpty, get } from "lodash"
import { parseRef, scrubUndefined } from "../../firebase"

import { defaultListener, generateId } from '../helper'

export default {
  state: {
    products: {},
    test: false,
  },
  getters: {
    allProducts(state) {
      return Object.values(state.products)
        .sort((a, b) => {
          return !!a.isArchived - !!b.isArchived
        })
    },
    getProduct: (state) => (id) => state.products[ id ] || {},
    getUnarchivedProducts(state) {
      return Object.values(state.products)
        .filter(p => p.isArchived !== false)
    },
    getProductOptionLabel: (state, getters) => (productId, optionNum) => {
      return get(getters.getProduct(productId), `options[${optionNum}].label`, '')
    },
    getUngroupedScheduledProducts(state) {
      const products = Object.values(state.products) || []

      return products.filter(p => isEmpty(p.scheduleGroup) && p.template === process.env.VUE_APP_SCHEDULED_PRODUCT_TEMPLATE_ID)
        .filter(p => !p.isArchived)
    },
    getScheduledProducts(state) {
      const products = Object.values(state.products) || []

      return products.filter(p => p.template === process.env.VUE_APP_SCHEDULED_PRODUCT_TEMPLATE_ID)
        .filter(p => !p.isArchived)
    }
  },
  actions: {
    ensureProduct({ getters, state, dispatch }, data) {
      const { id } = data || {}
      const product = state.products[ id ] || {}

      if (isEmpty(product) && id) {
        return dispatch('fetchProduct', data)
      } else {
        return product
      }
    },
    async fetchProduct({ commit }, data) {
      const { id } = data
      const product = await this.$api.get(`/api/product/${id}`)
        .then(res => {
          commit('ADD_PRODUCT', res.data)
          return res.data
        })

      return product
    },
    initProducts({ getters, commit }) {
      const sessionTenant = getters.getSessionTenant

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('products')
        .onSnapshot(defaultListener.bind(this, commit, 'ADD_PRODUCT', 'REMOVE_PRODUCT')
          , e => console.log(e))
    },
    async fetchProductWithVariants({}, data) {
      const { id } = data

      const product = await this.$api.get(`/api/product/${id}`)
    },
    async updateProductAndVariants({}, data) {
      const { id } = data

      // API handles filtering variables for now
      const result = await this.$api.patch(`/api/product/${id}`, { ...data })

      return result
    },
    async createProductAndVariants({}, data) {
      // API handles filtering variables for now
      const result = await this.$api.post(`/api/product`, { ...data })

      return result
    }
  },
  mutations: {
    ADD_PRODUCT(state, product) {
      const { id } = product

      if (id) {
        const newState = { ...state.products }
        newState[ id ] = product
        state.products = newState
      }
    },
    REMOVE_PRODUCT(state, id) {
      if (state.products[ id ]) {
        const newState = { ...state.products }
        delete newState[ id ]
        state.products = newState
      }
    }
  },
}
